import { Component } from '@angular/core';


@Component({
    selector: 'finesse',
    template: require('./finesse.component.html'),
    
})
export class FinesseComponent {

    constructor() {

    }
}


/** WEBPACK FOOTER **
 ** ./src/app/solutions/finesse/finesse.component.ts
 **/